import { light_offer_extended } from "../models/light_offer_extended";
import { format } from "date-fns";

type OfferWithClippableDates = light_offer_extended & {
  clippable_dates?: string | string[];
};

export default function isCouponOutOfRange(
  offer: OfferWithClippableDates,
  now: Date,
): boolean {
  const currentDateString = format(now, "yyyy-MM-dd");
  // If clippable_dates exists, use it for validation
  if (offer?.clippable_dates && offer.clippable_dates.length > 0) {
    if (Array.isArray(offer.clippable_dates)) {
      // If clippable_dates is an array, check if current date is in the array
      return !offer.clippable_dates.includes(currentDateString);
    } else {
      // If clippable_dates is a string, check if current date matches
      return offer.clippable_dates !== currentDateString;
    }
  }

  return false;
}
